<template>
  <div class="card-form">
    <page-main
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="reload"
      @openEditFormDialog="openEditFormDialog"
    >
      <page-header
        ref="header"
        slot="header"
        @query="getData"
        @reload="resetPage"
        @openEditFormDialog="openEditFormDialog"
      />
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </page-main>
    <EditFormDialog
      :visible.sync="editFormDialogOptions.visible"
      :title="editFormDialogOptions.title"
      :disabled="editFormDialogOptions.disabled"
      :templateCode="editFormDialogOptions.templateCode"
      @reload="reload"
    />
  </div>
</template>
<script>
import PageMain from './main'
import PageHeader from './header'
import BaseTable from '@/mixins/base-table'
import BasePage from '@/mixins/base-pagination'
import EditFormDialog from '../edit-form/dialog.vue'

export default {
  components: {
    PageHeader,
    PageMain,
    EditFormDialog,
  },
  mixins: [BaseTable, BasePage],
  data() {
    return {
      usePage: true,
      editFormDialogOptions: {
        visible: false,
      },
    }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .sysInoutTemplateListApi({
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
    openEditFormDialog({ type, row = {} }) {
      const types = {
        edit: this.$l('dialog_title_edit_system_template') || '编辑系统模板',
        add: this.$l('dialog_title_add_system_template') || '增加系统模板',
        detail:
          this.$l('dialog_title_system_template_details') || '系统模板详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        disabled: type === 'detail',
        templateCode: row.templateCode,
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
